<template>
  <div id="side-nav">
    <el-menu>
      <el-menu-item
        v-for="module in permittedModules"
        :key="module.id"
        :index="module.id"
        class="big"
      >
        <a :href="'#' + module">{{ module | concatenate }}</a>
      </el-menu-item>

      <hr />

      <!-- <el-menu-item class="small">
        <a href="#">View/Pay Invoice</a>
      </el-menu-item>

      <el-menu-item class="small">
        <a href="#">Download W9</a>
      </el-menu-item>

      <hr /> -->

      <div id="logo">Logo</div>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "SideNav",
  props: ["permittedModules"],
  filters: {
    concatenate: function(str) {
      return str.replace(/-/g, " ");
    }
  }
};
</script>

<style lang="scss" scoped>
#side-nav {
  height: calc(100% - 6rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 2.5rem;
}

hr {
  margin: 1.75rem 0 1.5rem;
  opacity: 0.56;
  border-width: 0px;
  border-bottom: 1px solid #ffffff;
}

#logo {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 20px;
  background-color: #ffffff;
  border-radius: 8px;

  font-weight: 700;
  font-size: 17px;
  color: rgba(144, 144, 144, 0.59);
  letter-spacing: 1.39px;
  line-height: 27px;
  text-transform: uppercase;
}

.el-menu {
  width: 212px;
  background-color: transparent !important;
  border-right: none !important;

  &-item {
    height: auto;
    line-height: 1;

    &:hover,
    &:focus {
      background-color: transparent;
    }

    &.big {
      margin-bottom: 1em;
      line-height: 22px;

      a {
        font-family: Lato-Heavy;
        font-size: 20px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 20px;
        text-transform: capitalize;
      }
    }

    &.small {
      line-height: 27px;

      a {
        font-weight: 700;
        font-size: 12px;
        letter-spacing: 0.77px;
        text-transform: uppercase;
      }
    }

    a {
      display: inline-block;
      white-space: pre-wrap;
      word-wrap: break-word;
      text-decoration: none;
      color: #ffffff;
    }
  }
}
</style>
